import { Card, message, Modal, Select } from 'antd';
import * as Component from 'components';
import { DUBBING_MODE, STATUS } from 'constants/constant';
import { seriesService } from 'content/service';
import React, { useState } from 'react';

interface SeriesBulkUpdateButtonProps {
  selectedList: number[];
}

const SeriesBulkUpdateButton = ({ selectedList }: SeriesBulkUpdateButtonProps): JSX.Element => {
  const [isBulkUpdateModalVisible, setIsBulkUpdateModalVisible] = useState(false);
  const [selectedDubbingMode, setSelectedDubbingMode] = useState<string>('');
  const [status, setStatus] = useState<string>('');

  return (
    <>
      <Component.CustomButtonComponent
        color="whte"
        text="Bulk Update"
        size="small"
        onClick={() => {
          setIsBulkUpdateModalVisible(true);
          setSelectedDubbingMode('');
          setStatus('');
        }}
      />
      <Modal
        title="Bulk Update"
        open={isBulkUpdateModalVisible}
        onCancel={() => {
          setIsBulkUpdateModalVisible(false);
          setSelectedDubbingMode('');
          setStatus('');
        }}
        onOk={async () => {
          message.info('Now bulk updating ...');
          const filteredIds = selectedList.filter(id => id);
          const filteredRecords = Object.fromEntries(
            Object.entries({
              dubbing_mode: selectedDubbingMode,
              status: status as 'draft' | 'unpublished' | 'published',
            }).filter(([_, value]) => value !== undefined && !!value)
          );
          await Promise.all(filteredIds.map(id => seriesService.update(id, filteredRecords)));
          message.success('Bulk update completed');
          window.location.reload();
          setIsBulkUpdateModalVisible(false);
        }}
      >
        <Card>
          <div style={{ display: 'flex', gap: 16 }}>
            <span>Dubbing Mode</span>
            <Select
              showSearch
              placeholder="Select Dubbing Mode"
              value={selectedDubbingMode}
              onChange={setSelectedDubbingMode}
              filterOption={(input, option) =>
                (option?.label as string).toLowerCase().includes(input.toLowerCase())
              }
              options={Object.values(DUBBING_MODE).map(dubbingMode => ({
                label: dubbingMode,
                value: dubbingMode.toLowerCase(),
              }))}
              style={{ width: '100%', marginBottom: 16 }}
            />
          </div>
          <div style={{ display: 'flex', gap: 16 }}>
            <span>Status</span>
            <Select
              value={status}
              onChange={setStatus}
              style={{ width: '100%' }}
              options={STATUS.map(status => ({
                label: status,
                value: status.toLowerCase(),
              }))}
            />
          </div>
        </Card>
      </Modal>
    </>
  );
};

export default SeriesBulkUpdateButton;
